import { RecalculationMessage } from 'app/ts/clientDto/RecalculationMessage';
export class RecalculationError extends Error {
  public constructor(
    public readonly recalculationMessage: RecalculationMessage,
  ) {
    super(recalculationMessage.key);
  }
}
